import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const CIRCLE_SIZE = 40;

export const useStyles = makeStyles<Theme>()((theme) => ({
  userConfigWrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  userConfigForm: {
    position: 'relative',
  },
  languageItem: {
    maxWidth: 'unset',
  },
  buttonWrapper: {
    padding: '16px 0',
  },
  userConfigContent: {
    '& > div + div': {
      marginTop: '16px',
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  colorSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  colorCirclesRow: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  colorCircle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: '50%',
    cursor: 'pointer',
    border: '3px solid transparent',
    transition: 'border-color 0.2s, transform 0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  colorCircleSelected: {
    borderColor: theme.palette.text.primary,
  },
  themeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
}));
